import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Button, Form, InputGroup } from 'react-bootstrap';

import Wrapper from '../../components/Wrapper';
import UserReportsTable from '../../components/tables/UserReportsTable';
import { fetchUserReports } from '../../store/features/userInfo';
import '../../styles/reports.css';

const UserReports = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  
  const [searchTerm, setSearchTerm] = useState('');

  const {
    allReports, 
    reportsStatus,
  } = useSelector((state) => state.userInfo);

  useEffect(() => {
    dispatch(fetchUserReports({ id }));
  }, [dispatch, id]);

  // Client-side filtering logic
  const filteredReports = allReports.filter((report) => 
    Object.values(report).some((val) => 
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <Wrapper>
      <div className='reports-container py-4'>
        <div className='d-flex flex-column flex-md-row justify-content-between mb-3 w-100'>
          <h1 className='fw-bolder'>Reports</h1>
          
          <div className='d-flex justify-content-end align-items-center position-relative mt-3 m-md-0'>
            {/* Search Bar */}
            <div className='position-relative mx-2'>
              <InputGroup className='border-2'>
                <Form.Control
                  placeholder='Search'
                  aria-label='Search'
                  type='text'
                  className='border-none outline-none'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Button
                  variant='primary'
                  className='rounded-end rounded-start-0'
                >
                  Search
                </Button>
              </InputGroup>
            </div>
          </div>
        </div>

        {reportsStatus === 'succeeded' || reportsStatus === 'idle' ? (
          <>
            <UserReportsTable reports={filteredReports} />
          </>
        ) : (
          <h2 className='text-center mt-5'>Loading...</h2>
        )}
      </div>
    </Wrapper>
  );
};

export default UserReports;